import { doSubscribeAjax, isFormValid } from "./util";

function Preferences() {
	this.$form = $("#email-preferences .subscribe-form");
	this.$checkbox = this.$form.find("#terms_agree");
    this.$subscribeButton = this.$form.find("button[type='submit']");

	this.init = () => {
		if (this.$form.length) {
			this.register();
			this.handleCheckbox();
		}
	};

	this.handleCheckbox = () => {
        this.$subscribeButton.prop('disabled', !this.$checkbox.is(':checked'));

        this.$checkbox.on('change', () => {
            this.$subscribeButton.prop('disabled', !this.$checkbox.is(':checked'));
        });
    };

	this.register = () => {
		this.$form.on("submit", (e) => this.submit(e));
	};

	this.submit = (e) => {
		e.preventDefault();

		if (isFormValid(this.$form)) {
			doSubscribeAjax(this.$form, null, null, () => {
				if (!this.$form.data("redirect")) {
					$("html, body").animate({ scrollTop: 0 }, 500);
				}
			});
		}
	};
}

export default new Preferences();
